<section>
	<h4 class="lvr-shared-list__title">{{ disabilityType()?.disabilityType?.remark }}</h4>
	<div class="lvr-shared-list__grid">
		<div class="lvr-shared-list__field" *lvrPermission="readPermissions">
			<span class="lvr-shared-list__field-label">{{ 'base.field.differentiation' | transloco }}:</span>
			<span class="lvr-shared-list__field-value">{{ disabilityType()?.categoryDiagnosis?.description || '-' }}</span>
		</div>
		<div class="lvr-shared-list__field" *lvrPermission="readPermissions">
			<span class="lvr-shared-list__field-label">{{ 'client.disability.type.edit.status_as_of' | transloco }}:</span>
			<span class="lvr-shared-list__field-value">
				{{ disabilityType()?.statusAsOf ? (disabilityType()?.statusAsOf | date: dateDisplayFormat) : '-' }}
			</span>
		</div>
		<div class="lvr-shared-list__field" *lvrPermission="readPermissions">
			<span class="lvr-shared-list__field-label">{{ 'base.field.documents' | transloco }}:</span>
			@if ((disabilityType()?.documents?.length ?? 0) > 0) {
				<ul class="documents-list">
					@for (doc of disabilityType()?.documents; track doc.id) {
						<li class="btn-link">
							<button type="button" class="documents-list__link btn-link" (click)="openDocument($event, doc)">
								<span class="documents-list__name">{{ doc.name }}</span>
							</button>
						</li>
					}
				</ul>
			} @else {
				<span class="lvr-shared-list__field-value">-</span>
			}
		</div>
	</div>
</section>
